import type { FC } from 'react';

import { fonts as enecoFonts } from '../../themes/eneco/default/tokens/typography';
import { fonts as oxxioFonts } from '../../themes/oxxio/tokens/typography';
import { fonts as woonenergieFonts } from '../../themes/woonenergie/tokens/typography';
import { getFontFaces } from '../../util';

/**
 * Generate the @font-face CSS string.
 * This is a function so it can dynamically evaluate environment variables like FE_STATIC_PREFIX
 * at runtime rather than at module load.
 */
export const getGlobalFontFaceCss = (prefix?: string) => {
  const allFontFaces = [
    ...getFontFaces(enecoFonts, prefix),
    ...getFontFaces(oxxioFonts, prefix),
    ...getFontFaces(woonenergieFonts, prefix),
  ];

  return allFontFaces
    .map(
      font => `
@font-face {
  font-family: '${font.fontFamily}';
  font-style: ${font.fontStyle};
  font-weight: ${font.fontWeight};
  font-display: ${font.fontDisplay};
  src: ${font.src};
}
`
    )
    .join('');
};

export const SparkyGlobalFonts: FC = () => {
  return <style id="sparky-global-fonts" dangerouslySetInnerHTML={{ __html: getGlobalFontFaceCss() }} />;
};
